import React from 'react';
import {Link} from 'react-router-dom';

const SurveyListLink = ({children, disabled, url}) => (
    disabled ?
        <a className="disabled">{children}</a> :
        <Link to={url}>{children}</Link>
);

export default SurveyListLink;
